const Extension = {
  Codes: {
    SNOMED: "SNOMED",
    ICD10: "ICD10",
  },
  Item: {
    Placeholder: "Placeholder",
    Label: "Label",
    Component: "Component",
    Description: "Description",
    Categories: "Categories",
    Prefix: "Prefix",
    Suffix: "Suffix",
    AddButtonLabel: "AddButtonLabel",
    MinValue: "MinValue",
    MaxValue: "MaxValue",
    Collapsible: "Collapsible",
  },
  Patient: {
    ReferralSource: "ReferralSource",
    CurrentOccupation: "CurrentOccupation",
    PreviousOccupations: "PreviousOccupations",
  },
};

export default Extension;
